import { useTranslation } from 'react-i18next';
import images from '../../assets/images';
import type { IRewardPartnerConnectionFailProps } from '../../types/propTypes';

const ConnectionFail = ({
  completionURL,
  errorTitle,
  errorMessage,
  returnToAppTitle,
}: IRewardPartnerConnectionFailProps) => {
  const { t } = useTranslation();

  const handleReturnToAppButtonClick = () => {
    window.location.href = completionURL;
  };

  return (
    <div className="connection-fail-wrapper text-center">
      <div className="mesg-box">
        <img src={images.errorIconSVG} alt="" />
        <h2 className="themeTextColor mt-4" style={{ paddingInline: '16px' }}>
          {errorTitle || t('rewardPartner.errors.somethingWentWrong')}
        </h2>
      </div>

      <div className="mt-4 lightTextColor px-4">
        <p className="errorMsg">{errorMessage || t('rewardPartner.errors.unableToConnectPartner')}</p>
      </div>

      <div className="clearfix mt-4">
        <button type="button" className="btn btn-primary return-to-app-btn" onClick={handleReturnToAppButtonClick}>
          <span>{returnToAppTitle || t('rewardPartner.button.returnToApp')}</span>
        </button>
      </div>
    </div>
  );
};

export default ConnectionFail;
